/**
 * 栄養成分情報VOクラス
 */
export class GoodsNutrientModel {
  /**
* Ｐコード
*/
  public pCode: string = <string>'';

  /**
   * アイテムコードコード
   */
  public itemCode: string = <string>'';

  /**
   * 分析連番
   */
  public analysisSeqNo: string = <string>'';

  /**
   * 栄養成分コード
   */
  public nutritionalCode: string = <string>'';

  /**
   * 栄養成分名
   */
  public nutritionalName: string = <string>'';

  /**
   * 栄養成分値
   */
  public nutritionalQuantity: string = <string>'';

  /**
   * 栄養成分単位
   */
  public nutrientUnit: string = <string>'';

  /**
   * 表示区分（0：誌面表示なし、1：あり）
   */
  public publishDiv: string = <string>'';

  /**
   * 階層
   */
  public hierarchy: string;
}